import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@webapp/auth';
import { CLIENT_DASHBOARD_ROUTE_PATH } from '@webapp/core/constants/client-routes';

function isSafeRelativeUrl(url: string | null): url is string {
  return !!url && url.startsWith('/') && !url.startsWith('//');
}

export const clientAccountGuard: CanActivateFn = (route) => {
  if (!inject(AuthService).isAuthenticated()) {
    return true;
  }

  const returnUrl = route.queryParamMap.get('returnUrl');
  const target = isSafeRelativeUrl(returnUrl) ? returnUrl : CLIENT_DASHBOARD_ROUTE_PATH;

  inject(Router).navigateByUrl(target);
  return false;
};
